{
  "PROFILE_SETTINGS": {
    "LINK": "Profilindstillinger",
    "TITLE": "Profilindstillinger",
    "BTN_TEXT": "Opdater Profil",
    "DELETE_AVATAR": "Slet Avatar",
    "AVATAR_DELETE_SUCCESS": "Avatar er blevet slettet",
    "AVATAR_DELETE_FAILED": "Der er en fejl under sletning af avatar, prøv igen",
    "UPDATE_SUCCESS": "Din profil er blevet opdateret",
    "PASSWORD_UPDATE_SUCCESS": "Din adgangskode er blevet ændret",
    "AFTER_EMAIL_CHANGED": "Din profil er blevet opdateret. Log venligst ind igen, da dine loginoplysninger er ændret",
    "FORM": {
      "PICTURE": "Profile Picture",
      "EMAIL_SIGNATURE_PICTURE": {
        "LABEL": "Billede til e-mailsignatur",
        "HINT": "Bruges i e-mailsignaturer. {'{{'}email_signature_picture{'}}'} erstattes med URL-adressen til dette billede (ikke et img-tag) — brug den som billedkilde (src i et img-tag) i din signatur eller indbakkens signatur. Hvis det ikke er angivet, indsættes intet.",
        "DELETE_SUCCESS": "Billedet til e-mailsignaturen er blevet slettet",
        "DELETE_FAILED": "Der opstod en fejl under sletning af billedet til e-mailsignaturen, prøv igen"
      },
      "AVATAR": "Profilbillede",
      "ERROR": "Ret venligst formularfejl",
      "REMOVE_IMAGE": "Fjern",
      "UPLOAD_IMAGE": "Upload billede",
      "UPDATE_IMAGE": "Opdater billede",
      "PROFILE_SECTION": {
        "TITLE": "Profil",
        "NOTE": "Din e-mailadresse er din identitet og bruges til at logge ind."
      },
      "SEND_MESSAGE": {
        "TITLE": "Genvejstast til at sende beskeder",
        "NOTE": "You can select a hotkey (either Enter or Cmd/Ctrl+Enter) based on your preference of writing.",
        "UPDATE_SUCCESS": "Dine indstillinger er blevet opdateret",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Enter (↵)",
            "CONTENT": "Send messages by pressing Enter key instead of clicking the send button."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Send messages by pressing Cmd/Ctrl + enter key instead of clicking the send button."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Interface",
        "NOTE": "Customize the look and feel of your dashboard.",
        "FONT_SIZE": {
          "TITLE": "Font size",
          "NOTE": "Adjust the text size across the dashboard based on your preference.",
          "UPDATE_SUCCESS": "Your font settings have been updated successfully",
          "UPDATE_ERROR": "There is an error while updating the font settings, please try again",
          "OPTIONS": {
            "SMALLER": "Smaller",
            "SMALL": "Small",
            "DEFAULT": "Standard",
            "LARGE": "Large",
            "LARGER": "Larger",
            "EXTRA_LARGE": "Extra Large"
          }
        },
        "UI_LANGUAGE": {
          "TITLE": "Dashboard-sprog",
          "NOTE": "Tilsidesæt kontoens sprog for dit eget dashboard. Lad stå tomt for at bruge kontoens standard.",
          "USE_ACCOUNT_DEFAULT": "Brug kontoens standard",
          "API_SUCCESS": "Dit dashboard-sprog er blevet opdateret"
        },
        "MESSAGE_TRANSLATION": {
          "TITLE": "Beskedsprog",
          "NOTE": "Vælg om oprindelige beskeder eller deres oversættelser skal vises",
          "ORIGINAL": "Original",
          "TRANSLATED": "Oversat"
        },
        "PASTE_BEHAVIOR": {
          "TITLE": "Indsætningsadfærd",
          "NOTE": "Vælg hvordan indsat indhold skal behandles, når du skriver beskeder",
          "UPDATE_SUCCESS": "Dine indsætningsindstillinger er blevet opdateret",
          "OPTIONS": {
            "PRESERVE_ALL": {
              "HEADING": "Bevar al formatering",
              "DESCRIPTION": "Bevar al formatering, herunder tabeller, typografier og andre HTML-elementer, når du indsætter indhold."
            },
            "TEXT_WITH_LINKS": {
              "HEADING": "Kun tekst med links",
              "DESCRIPTION": "Konverter til almindelig tekst, men bevar klikbare links, når du indsætter indhold."
            },
            "PLAIN_TEXT_ONLY": {
              "HEADING": "Kun almindelig tekst",
              "DESCRIPTION": "Fjern al formatering og konverter til almindelig tekst, når du indsætter indhold."
            }
          }
        },
        "REPLY_BOX_HEIGHT": {
          "TITLE": "Højde på svarboksen",
          "NOTE": "Angiv minimumshøjden for svarboksen som en procentdel af skærmhøjden. Gælder kun for e-mailsamtaler.",
          "UPDATE_SUCCESS": "Din indstilling for svarboksens højde er blevet opdateret",
          "PERCENT_LABEL": "Højde (% af skærmhøjden)",
          "OPTIONS": {
            "DEFAULT": {
              "HEADING": "Standard",
              "DESCRIPTION": "Svarboksen starter lille og vokser, mens du skriver."
            },
            "CUSTOM": {
              "HEADING": "Tilpasset",
              "DESCRIPTION": "Svarboksen har altid mindst den valgte procentdel af skærmhøjden."
            }
          }
        }
      },
      "AUTO_NAVIGATION": {
        "TITLE": "Naviger automatisk til næste samtale",
        "NOTE": "Skift automatisk til næste åbne samtale, når den nuværende er løst",
        "UPDATE_SUCCESS": "Indstillingen for automatisk navigation er blevet opdateret"
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Personlig beskedsignatur",
        "DESCRIPTION": "Opret en unik beskedsignatur, der vises i slutningen af hver e-mail, du sender. Du kan også tilføje et indlejret billede.",
        "NOTE": "Create a unique message signature to appear at the end of every message you send from any inbox. You can also include an inline image, which is supported in live-chat, email, and API inboxes.",
        "BTN_TEXT": "Gem beskedsignatur",
        "API_ERROR": "Kunne ikke gemme signatur! Prøv igen",
        "API_SUCCESS": "Signatur gemt",
        "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
        "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save to save the signature",
        "IMAGE_UPLOAD_SIZE_ERROR": "Billedets størrelse skal være mindre end {size}MB"
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Besked Signatur",
        "ERROR": "Beskedsignatur kan ikke være tom",
        "PLACEHOLDER": "Indsæt din personlige beskedsignatur her."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Adgangskode",
        "NOTE": "Opdatering af din adgangskode vil nulstille dine logins på flere enheder.",
        "BTN_TEXT": "Skift adgangskode"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Adgangs Token",
        "NOTE": "Denne token kan bruges, hvis du bygger en API-baseret integration",
        "COPY": "Kopiér",
        "REGENERATE": "Generer igen",
        "REGENERATE_SUCCESS": "Adgangstokenet er blevet genereret igen. Opdater venligst eventuelle integrationer, der bruger det gamle token.",
        "REGENERATE_CONFIRM_TITLE": "Generer adgangstoken igen?",
        "REGENERATE_CONFIRM_MESSAGE": "Dette vil gøre det nuværende token ugyldigt. Eventuelle integrationer, der bruger det gamle token, holder op med at virke."
      },
      "CHROME_EXTENSION": {
        "TITLE": "Chrome-udvidelse",
        "NOTE": "Installer vores Chrome-udvidelse for at få udførlige notifikationer om indgående telefonopkald.",
        "INSTALL_BUTTON": "Installer udvidelse",
        "ALREADY_INSTALLED": "Udvidelse installeret"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Audio Alerts",
        "NOTE": "Enable audio alerts in dashboard for new messages and conversations.",
        "PLAY": "Play sound",
        "ALERT_TYPES": {
          "NONE": "Ingen",
          "MINE": "Assigned",
          "ALL": "Alle",
          "ASSIGNED": "My assigned conversations",
          "UNASSIGNED": "Unassigned conversations",
          "NOTME": "Open conversations assigned to others"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "You haven't selected any options, you won't receive any audio alerts.",
          "ASSIGNED": "You'll receive alerts for conversations assigned to you.",
          "UNASSIGNED": "You'll receive alerts for any unassigned conversations.",
          "NOTME": "You'll receive alerts for conversations assigned to others.",
          "ASSIGNED+UNASSIGNED": "You'll receive alerts for your assigned conversations and any unattended ones.",
          "ASSIGNED+NOTME": "You'll receive alerts for conversations assigned to you and to others, but not for unassigned ones.",
          "NOTME+UNASSIGNED": "You'll receive alerts for unattended conversations and those assigned to others.",
          "ASSIGNED+NOTME+UNASSIGNED": "You'll receive alerts for all conversations."
        },
        "ALERT_TYPE": {
          "TITLE": "Alert events for conversations",
          "NONE": "Ingen",
          "ASSIGNED": "Tildelte Samtaler",
          "ALL_CONVERSATIONS": "Alle Samtaler"
        },
        "DEFAULT_TONE": {
          "TITLE": "Alert tone:"
        },
        "CONDITIONS": {
          "TITLE": "Alert conditions:",
          "CONDITION_ONE": "Send audio alerts only if the browser window is not active",
          "CONDITION_TWO": "Send alerts every 10s until all the assigned conversations are read"
        },
        "SOUND_PERMISSION_ERROR": "Autoplay is disabled in your browser. To hear alerts automatically, enable sound permission in your browser settings or interact with the page.",
        "READ_MORE": "Read more"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "E-Mail Notifikationer",
        "NOTE": "Opdater dine e-mail notifikationspræferencer her",
        "CONVERSATION_ASSIGNMENT": "Send e-mail notifikationer når en samtale er tildelt mig",
        "CONVERSATION_CREATION": "Send e-mail notifikationer når en ny samtale er oprettet",
        "CONVERSATION_MENTION": "Send e-mail notifikationer, når du er nævnt i en samtale",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Send e-mail notifikationer når en ny besked er oprettet i en tildelt samtale",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Send email notifications when a new message is created in a participating conversation",
        "SLA_MISSED_FIRST_RESPONSE": "Send email notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send email notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send email notifications when a conversation misses resolution SLA"
      },
      "NOTIFICATIONS": {
        "TITLE": "Notification preferences",
        "TYPE_TITLE": "Notification type",
        "EMAIL": "E-mail",
        "PUSH": "Push notification",
        "TYPES": {
          "CONVERSATION_CREATED": "A new conversation is created",
          "CONVERSATION_ASSIGNED": "A conversation is assigned to you",
          "CONVERSATION_MENTION": "You are mentioned in a conversation",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "A new message is created in an assigned conversation",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "A new message is created in a participating conversation",
          "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "Der oprettes en ny besked i en samtale uden en tilgængelig agent",
          "SLA_MISSED_FIRST_RESPONSE": "A conversation misses first response SLA",
          "SLA_MISSED_NEXT_RESPONSE": "A conversation misses next response SLA",
          "SLA_MISSED_RESOLUTION": "A conversation misses resolution SLA"
        },
        "BROWSER_PERMISSION": "Enable push notifications for your browser so you’re able to receive them",
        "ALLOW_NOTIFICATION_DURING_CALL": "Tillad push-notifikationer, mens du er i et opkald",
        "TEST_PUSH": "Test",
        "TESTING": "Tester...",
        "TEST_PUSH_DESCRIPTION": "Send test-notifikationer for at bekræfte din opsætning",
        "TEST_NOTIFICATION_ERROR": "Kunne ikke sende test-notifikationen. Prøv venligst igen.",
        "TEST_LOCAL_TITLE": "Test-notifikation (lokal)",
        "TEST_LOCAL_BODY": "Dette er en lokal browsernotifikation. Hvis du ser denne, virker browsernotifikationer!"
      },
      "API": {
        "UPDATE_SUCCESS": "Dine notifikationsindstillinger er opdateret",
        "UPDATE_ERROR": "Der er en fejl under opdatering af indstillingerne, prøv venligst igen"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Push Notifikationer",
        "NOTE": "Opdater dine push-notifikationspræferencer her",
        "CONVERSATION_ASSIGNMENT": "Send push-notifikationer, når en samtale er tildelt mig",
        "CONVERSATION_CREATION": "Send push-notifikationer, når en ny samtale er oprettet",
        "CONVERSATION_MENTION": "Send push-notifikationer, når du er nævnt i en samtale",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Send push-notifikationer, når en ny besked oprettes i en tildelt samtale",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Send push notifications when a new message is created in a participating conversation",
        "HAS_ENABLED_PUSH": "Du har aktiveret push for denne browser.",
        "REQUEST_PUSH": "Aktivér push-notifikationer",
        "SLA_MISSED_FIRST_RESPONSE": "Send push notifications when a conversation misses first response SLA",
        "SLA_MISSED_NEXT_RESPONSE": "Send push notifications when a conversation misses next response SLA",
        "SLA_MISSED_RESOLUTION": "Send push notifications when a conversation misses resolution SLA"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Profilbillede"
      },
      "NAME": {
        "LABEL": "Dit fulde navn",
        "ERROR": "Indtast et gyldigt fuldt navn",
        "PLACEHOLDER": "Indtast venligst dit fulde navn"
      },
      "DISPLAY_NAME": {
        "LABEL": "Display navn",
        "ERROR": "Angiv et gyldigt displaynavn",
        "PLACEHOLDER": "Angiv venligst et displaynavn, dette vil blive vist i samtaler"
      },
      "POSITION": {
        "LABEL": "Stilling",
        "ERROR": "Angiv en gyldig stilling",
        "PLACEHOLDER": "Angiv din stilling"
      },
      "CUSTOM_LINE": {
        "LABEL": "Tilpasset linje",
        "ERROR": "Angiv en gyldig tilpasset linje",
        "PLACEHOLDER": "Angiv din tilpassede linje"
      },
      "AVAILABILITY": {
        "LABEL": "Tilgængelighed",
        "STATUS": {
          "ONLINE": "Online",
          "BUSY": "Optaget",
          "OFFLINE": "Offline"
        },
        "SET_AVAILABILITY_SUCCESS": "Availability has been set successfully",
        "SET_AVAILABILITY_ERROR": "Couldn't set availability, please try again"
      },
      "EMAIL_PREVIEW_FORMAT": {
        "TITLE": "Format for e-mailforhåndsvisning i samtaleliste",
        "NOTE": "Vælg, hvad der vises i samtalelisten for samtaler fra e-mail-postkasser",
        "SUBJECT": "Emne",
        "SUBJECT_WITH_NOTE": "Emne og seneste besked, hvis det er en privat note",
        "UPDATE_SUCCESS": "Indstilling for e-mailforhåndsvisning blev opdateret"
      },
      "DISABLE_SHORTCUTS": {
        "TITLE": "Deaktiver tastaturgenveje",
        "NOTE": "Slå alle tastaturgenveje fra i hele applikationen",
        "UPDATE_SUCCESS": "Indstillingen for tastaturgenveje er blevet opdateret"
      },
      "FOLDER_ORDER": {
        "TITLE": "Rækkefølge for mapper",
        "NOTE": "Tilpas den rækkefølge, mapper (tilpassede visninger) vises i i sidepanelet. Træk og slip for at ændre rækkefølgen.",
        "NO_FOLDERS": "Ingen tilpassede mapper fundet. Opret mapper for at organisere dine samtaler."
      },
      "SIDEBAR_CONFIGURATION": {
        "TITLE": "Konfiguration af sidepanel",
        "NOTE": "Tilpas hvilke sektioner der vises i samtalernes sidepanel.",
        "SAVE_BUTTON": "Gem konfiguration",
        "UPDATE_SUCCESS": "Konfigurationen af sidepanelet er blevet opdateret",
        "UPDATE_ERROR": "Der opstod en fejl under opdatering af sidepanelets konfiguration, prøv venligst igen",
        "OPTIONS": {
          "ALL_CONVERSATIONS": "Alle Samtaler",
          "ALL_CONVERSATIONS_DESC": "Vis menupunktet Alle Samtaler i sidepanelet",
          "INBOX": "Indbakke",
          "INBOX_DESC": "Vis hovedindbakken med ulæste notifikationer",
          "CONVERSATION_GROUPS": "Omtaler og ubehandlede",
          "CONVERSATION_GROUPS_DESC": "Vis grupperne Omtaler og Ubehandlede",
          "FOLDERS": "Mapper",
          "FOLDERS_DESC": "Vis tilpassede visninger (mapper) til organiserede samtaler",
          "TEAMS": "Teams",
          "TEAMS_DESC": "Vis samtaler filtreret efter team-tildeling",
          "CHANNELS": "Indbakker",
          "CHANNELS_DESC": "Vis samtaler filtreret efter indbakke",
          "LABELS": "Etiketter",
          "LABELS_DESC": "Vis samtaler filtreret efter etiketter"
        }
      },
      "PHONE_SETTINGS": {
        "TITLE": "Telefonindstillinger",
        "NOTE": "Indtast loginoplysninger til dit PBX-system.",
        "USERNAME": "Brugernavn",
        "PASSWORD": "Adgangskode",
        "SUBMIT": "Gem",
        "USERNAME_INVALID": "Brugernavnet må kun indeholde bogstaver, tal og . _ - + — ingen mellemrum og ingen e-mailadresse.",
        "API": {
          "USERNAME_INVALID": "Brugernavnet er ikke et gyldigt SIP-brugernavn. Brug kun bogstaver, tal og . _ - + — ingen mellemrum og ingen e-mailadresse.",
          "USERNAME_TAKEN": "Dette brugernavn bruges allerede af en anden agent på denne konto."
        }
      },
      "EMAIL": {
        "LABEL": "Din e-mail adresse",
        "ERROR": "Indtast venligst en gyldig e-mailadresse",
        "PLACEHOLDER": "Indtast venligst din e-mailadresse, dette vil blive vist i samtaler"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Nuværende adgangskode",
        "ERROR": "Indtast den aktuelle adgangskode",
        "PLACEHOLDER": "Indtast den aktuelle adgangskode"
      },
      "PASSWORD": {
        "LABEL": "Ny adgangskode",
        "ERROR": "Indtast en adgangskode med længde 6 eller flere",
        "PLACEHOLDER": "Indtast venligst en ny adgangskode"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Bekræft ny adgangskode",
        "ERROR": "Bekræftelses adgangskoden skal matche adgangskoden",
        "PLACEHOLDER": "Indtast venligst din nye adgangskode igen"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Skift",
    "CHANGE_ACCOUNTS": "Switch account",
    "SWITCH_ACCOUNT": "Switch account",
    "CONTACT_SUPPORT": "Contact support",
    "REPORT_BUG": "Rapporter en fejl",
    "SELECTOR_SUBTITLE": "Vælg en konto fra følgende liste",
    "PROFILE_SETTINGS": "Profile settings",
    "KEYBOARD_SHORTCUTS": "Keyboard shortcuts",
    "APPEARANCE": "Change appearance",
    "SUPER_ADMIN_CONSOLE": "SuperAdmin console",
    "DOCS": "Read documentation",
    "LOGOUT": "Log out"
  },
  "BUG_REPORT": {
    "TITLE": "Rapporter en fejl",
    "DESCRIPTION_LABEL": "Beskrivelse af problemet",
    "DESCRIPTION_PLACEHOLDER": "Beskriv det problem, du oplevede...",
    "SUBMIT": "Send rapport",
    "SUBMITTING": "Sender...",
    "CANCEL": "Annuller",
    "SUCCESS": "Fejlrapporten er sendt. Tak!",
    "VALIDATION_ERROR": "Beskriv problemet, før du sender rapporten"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "dage prøveperiode tilbage.",
    "TRAIL_BUTTON": "Køb Nu",
    "DELETED_USER": "Slettet Bruger",
    "EMAIL_VERIFICATION_PENDING": "It seems that you haven't verified your email address yet. Please check your inbox for the verification email.",
    "RESEND_VERIFICATION_MAIL": "Resend verification email",
    "EMAIL_VERIFICATION_SENT": "Verification email has been sent. Please check your inbox.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Konto Suspenderet",
      "MESSAGE": "Din konto er suspenderet. Gå ud til supportteamet for mere information."
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Kopiér",
      "CODEPEN": "Open in CodePen",
      "COPY_SUCCESSFUL": "Kode kopieret til udklipsholder med succes"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Vis Mere",
      "SHOW_LESS": "Vis Mindre"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Download",
      "UPLOADING": "Uploader...",
      "INSTAGRAM_STORY_UNAVAILABLE": "Denne historie er ikke længere tilgængelig.",
      "RECORDING_UNAVAILABLE": "Denne optagelse er ikke længere tilgængelig.",
      "DELETE_RECORDING": {
        "BUTTON": "Slet opkaldsoptagelse",
        "TITLE": "Slet opkaldsoptagelsen?",
        "DESCRIPTION": "Alle optagelser af dette opkald slettes permanent fra telefonsystemet og kan ikke gendannes. Transskriptionen og resuméet af opkaldet bevares.",
        "CONFIRM": "Slet",
        "SUCCESS": "Opkaldsoptagelsen er slettet",
        "ERROR": "Opkaldsoptagelsen kunne ikke slettes. Prøv igen."
      }
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "Se på kort"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Send"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "This image is no longer available.",
      "LOADING_FAILED": "Loading failed"
    }
  },
  "CONFIRM_EMAIL": "Verificerer...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Tilføj Indbakke"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "No items",
    "CURRENTLY_VIEWING_ACCOUNT": "Vises nu:",
    "SWITCH": "Skift",
    "INBOX_VIEW": "Inbox View",
    "CONVERSATIONS": "Samtaler",
    "INBOX": "My Inbox",
    "ALL_CONVERSATIONS": "Alle Samtaler",
    "MENTIONED_CONVERSATIONS": "Omtaler",
    "PARTICIPATING_CONVERSATIONS": "Participating",
    "UNATTENDED_CONVERSATIONS": "Unattet",
    "REPORTS": "Rapporter",
    "SETTINGS": "Indstillinger",
    "CONTACTS": "Kontakter",
    "DATA_ASSISTANT": "Data-assistent",
    "CAPTAIN": "Captain",
    "CAPTAIN_ASSISTANTS": "Assistants",
    "CAPTAIN_DOCUMENTS": "Documents",
    "CAPTAIN_RESPONSES": "FAQs",
    "HOME": "Hjem",
    "AGENTS": "Agenter",
    "AGENT_BOTS": "Bots",
    "AUDIT_LOGS": "Audit Logs",
    "WHATSAPP_TEMPLATES": "WhatsApp-skabeloner",
    "BLOCKED_DOMAINS": "SPAM",
    "INBOXES": "Indbakker",
    "NOTIFICATIONS": "Notifikationer",
    "CANNED_RESPONSES": "Standardsvar Svar",
    "INTEGRATIONS": "Integrationer",
    "PROFILE_SETTINGS": "Profilindstillinger",
    "ACCOUNT_SETTINGS": "Kontoindstillinger",
    "APPLICATIONS": "Applikationer",
    "LABELS": "Etiketter",
    "CUSTOM_ATTRIBUTES": "Brugerdefinerede Egenskaber",
    "AUTOMATION": "Automatisering",
    "MACROS": "Macros",
    "TEAMS": "Teams",
    "BILLING": "Fakturering",
    "CUSTOM_VIEWS_FOLDER": "Mapper",
    "CUSTOM_VIEWS_SEGMENTS": "Segmenter",
    "ALL_CONTACTS": "Alle Kontakter",
    "TAGGED_WITH": "Mærket med",
    "NEW_LABEL": "Ny label",
    "NEW_TEAM": "Nyt team",
    "NEW_INBOX": "Ny indbakke",
    "REPORTS_CONVERSATION": "Samtaler",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Live Chat",
    "SMS": "SMS",
    "CAMPAIGNS": "Kampagner",
    "ONGOING": "Igangværende",
    "ONE_OFF": "En rabat",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Bot",
    "REPORTS_AGENT": "Agenter",
    "REPORTS_LABEL": "Etiketter",
    "REPORTS_INBOX": "Indbakke",
    "REPORTS_TEAM": "Team",
    "REPORTS_PHONE": "Telefon",
    "WALLBOARD": "Wallboard",
    "WALLBOARD_OVERVIEW": "Oversigt",
    "WALLBOARD_QUEUES": "Køer",
    "DATA_ASSISTANT_CHAT": "Chat",
    "DATA_ASSISTANT_REPORTS": "Rapporter",
    "NO_WAITING_CALLERS": "ingen ventende opkaldere",
    "WAITING_CALLERS": "{count} ventende opkaldere",
    "SET_AVAILABILITY_TITLE": "Sæt dig selv som",
    "SET_YOUR_AVAILABILITY": "Indstil din tilgængelighed",
    "AVAILABILITY_IMPERSONATING": "Låst, mens du er logget ind som denne bruger",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Custom Roles",
    "NEW_CONVERSATION": "Ny samtale",
    "DRAFT": "Kladde",
    "BETA": "Beta",
    "REPORTS_OVERVIEW": "Oversigt",
    "REAUTHORIZE": "Your inbox connection has expired, please reconnect\n to continue receiving and sending messages",
    "HELP_CENTER": {
      "TITLE": "Help Center",
      "ARTICLES": "Articles",
      "CATEGORIES": "Kategorier",
      "LOCALES": "Locales",
      "SETTINGS": "Indstillinger",
      "DICTIONARY": "Ordbog"
    },
    "CHANNELS": "Kanaler",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Mark offline automatically",
      "INFO_TEXT": "Let the system automatically mark you offline when you aren't using the app or dashboard.",
      "INFO_SHORT": "Automatically mark offline when you aren't using the app."
    },
    "DOCS": "Læs dokumenter"
  },
  "BLOCKED_DOMAINS_SETTINGS": {
    "HEADER": "Blokerede domæner og kontakter",
    "DESCRIPTION": "Liste over blokerede e-maildomæner for denne konto.",
    "NO_BLOCKED_DOMAINS": "Ingen blokerede domæner fundet.",
    "BLOCKED_CONTACTS_BTN": "Blokerede kontakter"
  },
  "BILLING_SETTINGS": {
    "TITLE": "Fakturering",
    "DESCRIPTION": "Manage your subscription here, upgrade your plan and get more for your team.",
    "CURRENT_PLAN": {
      "TITLE": "Nuværende Abonnement",
      "PLAN_NOTE": "Du abonnerer i øjeblikket på **{plan}** planen med **{quantity}** licenser",
      "SEAT_COUNT": "Number of seats",
      "RENEWS_ON": "Renews on"
    },
    "VIEW_PRICING": "View Pricing",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Administrer dit abonnement",
      "DESCRIPTION": "Se dine tidligere fakturaer, rediger dine fakturaoplysninger eller annuller dit abonnement.",
      "BUTTON_TXT": "Gå til faktureringsportalen"
    },
    "CAPTAIN": {
      "TITLE": "Captain",
      "DESCRIPTION": "Manage usage and credits for Captain AI.",
      "BUTTON_TXT": "Buy more credits",
      "DOCUMENTS": "Documents",
      "RESPONSES": "Responses",
      "UPGRADE": "Captain is not available on the free plan, upgrade now to get access to assistants, copilot and more."
    },
    "CHAT_WITH_US": {
      "TITLE": "Brug for hjælp?",
      "DESCRIPTION": "Har du problemer med fakturering? Vi er her for at hjælpe.",
      "BUTTON_TXT": "Chat med os"
    },
    "NO_BILLING_USER": "Din faktureringskonto er ved at blive konfigureret. Opdater venligst siden og prøv igen."
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Uh oh! Vi kunne ikke finde nogen konti. Opret venligst en ny konto for at fortsætte.",
    "NEW_ACCOUNT": "Ny Konto",
    "SELECTOR_SUBTITLE": "Opret en ny konto",
    "API": {
      "SUCCESS_MESSAGE": "Konto oprettet med succes",
      "EXIST_MESSAGE": "Konto findes allerede",
      "ERROR_MESSAGE": "Kunne ikke oprette forbindelse til Woot Server, Prøv igen senere"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Virksomhedens Navn",
        "PLACEHOLDER": "Wayne Enterprises"
      },
      "SUBMIT": "Send",
      "CANCEL": "Annuller"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "View all shortcuts",
    "TITLE": {
      "OPEN_CONVERSATION": "Åbn samtale",
      "RESOLVE_AND_NEXT": "Løs og flyt til næste",
      "NAVIGATE_DROPDOWN": "Naviger rullemenuer",
      "RESOLVE_CONVERSATION": "Løs Samtale",
      "GO_TO_CONVERSATION_DASHBOARD": "Gå til Konversationspanel",
      "ADD_ATTACHMENT": "Tilføj Vedhæftning",
      "GO_TO_CONTACTS_DASHBOARD": "Gå til Contacts Dashboard",
      "TOGGLE_SIDEBAR": "Slå Sidebjælke Til/Fra",
      "GO_TO_REPORTS_SIDEBAR": "Gå til Rapporter sidepanel",
      "MOVE_TO_NEXT_TAB": "Flyt til næste fane i samtalelisten",
      "GO_TO_SETTINGS": "Gå til Indstillinger",
      "SWITCH_TO_PRIVATE_NOTE": "Skift til privat note",
      "SWITCH_TO_REPLY": "Skift til svar",
      "TOGGLE_SNOOZE_DROPDOWN": "Skift snooze dropdown",
      "AI_ASSIST_MENU": "AI-assistance",
      "AI_ASSIST_GRAMMAR": "Ret grammatik",
      "AI_ASSIST_UNIFY_LANG": "Ensret beskedens sprog"
    }
  }
}
